const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#b22a1c',
                hover: '#a01c0f'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
